import React, { useState } from 'react';
import { bearerHeaders } from '../api.ts';
import { getTheme, useThemeMode } from '../theme';
import { apiFetch } from '../appFetch';

export function BackupSection() {
  const [importing, setImporting] = useState(false);
  const [msg, setMsg] = useState('');
  const T = getTheme(useThemeMode().mode);
  const cS = { background: T.surface, border: `1px solid ${T.border}`, borderRadius: 7, padding: '16px 18px', marginTop: 12 } as React.CSSProperties;

  async function doExport() {
    const token = localStorage.getItem('qvenari_access_token') || '';
    try {
      const r = await apiFetch('/api/export', { headers: { ...bearerHeaders(token) } });
      if (!r.ok) { const e = await r.json().catch(() => ({})); setMsg('Export misslyckades: ' + (e.error || r.status)); return; }
      const blob = await r.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      const date = new Date().toISOString().slice(0, 10);
      a.download = `qvenari-backup-${date}.json`;
      a.click();
      URL.revokeObjectURL(url);
      setMsg('✅ Backup nedladdad!');
    } catch (e: any) { setMsg('Fel: ' + e.message); }
  }

  function doImport() {
    const inp = document.createElement('input');
    inp.type = 'file'; inp.accept = '.json,application/json';
    inp.onchange = async () => {
      const file = inp.files?.[0]; if (!file) return;
      setImporting(true); setMsg('Läser fil...');
      try {
        const text = await file.text();
        const json = JSON.parse(text);
        const token = localStorage.getItem('qvenari_access_token') || '';
        const r = await apiFetch('/api/import', { method: 'POST', headers: { 'Content-Type': 'application/json', ...bearerHeaders(token) }, body: JSON.stringify(json) });
        const res = await r.json().catch(() => ({}));
        if (!r.ok) { setMsg('Import misslyckades: ' + (res.error || r.status)); }
        else { setMsg(`✅ ${res.message || 'Import klar!'}`); }
      } catch (e: any) { setMsg('Fel: ' + e.message); }
      finally { setImporting(false); }
    };
    inp.click();
  }

  return (
    <div style={{ ...cS }}>
      <div style={{ fontSize: 11, fontWeight: 700, color: T.amber, letterSpacing: 1, marginBottom: 12, textTransform: 'uppercase' }}>Databas-backup</div>
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
        <button onClick={doExport} style={{ background: T.amber, color: '#000', border: 'none', borderRadius: 6, padding: '9px 18px', fontWeight: 700, cursor: 'pointer', fontSize: 13 }}>
          Ladda ner backup
        </button>
        <button onClick={doImport} disabled={importing} style={{ background: importing ? T.border : '#2563eb', color: '#fff', border: 'none', borderRadius: 6, padding: '9px 18px', fontWeight: 700, cursor: importing ? 'not-allowed' : 'pointer', fontSize: 13 }}>
          {importing ? 'Importerar...' : 'Återställ från backup'}
        </button>
      </div>
      {msg && <div style={{ fontSize: 12, color: msg.startsWith('✅') ? '#4ade80' : '#f87171', marginTop: 10 }}>{msg}</div>}
    </div>
  );
}
